<template>
  <div class="my-register-page">
    <div class="my-container">
      <b-row class="mb-2 mt-2 pt-1">
        <b-col sm="12" class="text-center">
          <h1>{{ $t("inspectionbookAll") }}</h1>
        </b-col>
      </b-row>

      <b-table-simple bordered>
        <b-thead class="text-center">
          <b-tr variant="primary">
            <b-th style="vertical-align: middle">
              {{ $t("orderCode") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("docNumber") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("checkDate") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("orderedOrganization") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("inspectionOrganization") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("checkType") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("contractorFilledFilter") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("actions") }}
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr>
            <b-td>
              <!-- <b-form-input
                @keyup.enter="Refresh"
                v-model="filter.filters.orderNumber.value"
                :placeholder="$t('orderCode')"
              ></b-form-input> -->
            </b-td>
            <b-td>
              <b-form-input
                @keyup.enter="Refresh"
                v-model="filter.filters.docNumber.value"
                :placeholder="$t('docNumber')"
              ></b-form-input>
            </b-td>
            <b-td> </b-td>
            <b-td>
              <b-form-input
                @keyup.enter="Refresh"
                v-model="filter.filters.orderedOrganization.value"
                :placeholder="$t('orderedOrganization')"
              ></b-form-input>
            </b-td>
            <b-td>
              <b-form-input
                @keyup.enter="Refresh"
                v-model="filter.filters.inspectionOrganizationName.value"
                :placeholder="$t('inspectionOrganization')"
              ></b-form-input>
            </b-td>
            <b-td>
              <b-form-select
                class="filter-select"
                v-model="filter.filters.typeId.value"
                :options="typeOptions"
                @change="Refresh"
              ></b-form-select>
            </b-td>
            <b-td>
              <b-form-select
                class="filter-select"
                v-model="filter.filters.isContractorFilled.value"
                :options="contractorFilledOptions"
                @change="Refresh"
              ></b-form-select>
            </b-td>
            <b-td style="vertical-align: middle; text-align: center">
              <b-button
                variant="primary"
                size="sm"
                v-b-tooltip.hover
                :title="$t('Search')"
                @click="Refresh"
              >
                <b-icon icon="search"></b-icon>
              </b-button>
            </b-td>
          </b-tr>
          <b-tr v-for="(item, index) in Requests" :key="index">
            <b-td class="text-nowrap" style="vertical-align: middle">
              {{ item.orderCode }}
            </b-td>
            <b-td class="text-nowrap" style="vertical-align: middle">
              {{ item.docNumber }}
            </b-td>
            <b-td style="white-space: nowrap">
              {{ item.startDate }} - {{ item.endDate }} ({{
                item.checkDaysNumber
              }}
              {{ $t("day") }} )
            </b-td>
            <b-td>
              {{ item.orderedOrganization }}
            </b-td>
            <b-td>
              {{ item.inspectionOrganizationName }}
            </b-td>
            <b-td>
              {{ item.checkType }}
            </b-td>
            <b-td class="text-center" style="vertical-align: middle">
              <b-badge :class="isContractorFilled(item) ? 'text-bg-success' : 'text-bg-secondary'">
                {{
                  isContractorFilled(item)
                    ? $t("contractorFilledYes")
                    : $t("contractorFilledNo")
                }}
              </b-badge>
            </b-td>
            <b-td style="vertical-align: middle; text-align: center; white-space: nowrap">
              <b-icon
                v-b-tooltip.hover
                :title="$t('View')"
                style="cursor: pointer; color: #0d6efd"
                @click="View(item)"
                icon="eye"
              ></b-icon>
              <b-icon
                v-b-tooltip.hover
                :title="$t('contractorFillAction')"
                style="cursor: pointer; color: #198754; margin-left: 12px"
                @click="Fill(item)"
                icon="pencil-square"
              ></b-icon>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <div>
        <b-pagination
          v-model="filter.page"
          :total-rows="filter.totalRows"
          :per-page="filter.pageSize"
          first-number
          last-number
          @input="Refresh"
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <b-icon icon="chevron-double-left" size="18" />
          </template>
          <template #next-text>
            <b-icon icon="chevron-double-right" size="18" />
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import InspectionBookService from "@/services/inspectionbook.service";
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BBadge,
  BIconEyeFill,
  BPagination,
  BFormInput,
  BFormSelect,
} from "bootstrap-vue";
export default {
  data() {
    return {
      Requests: [],
      filter: {
        search: "",
        page: 1,
        pageSize: 20,
        totalRows: 1,
        options: [
          { value: 10, text: "10" },
          { value: 20, text: "20" },
          { value: 50, text: "50" },
          { value: 100, text: "100" },
        ],
        filters: {
          docNumber: {
            value: "",
            matchmode: "contains",
          },
          orderNumber: {
            value: "",
            matchmode: "contains",
          },
          inspectionOrganizationName: {
            value: "",
            matchmode: "contains",
          },
          orderedOrganization: {
            value: "",
            matchmode: "contains",
          },
          isContractorFilled: {
            value: null,
            matchmode: "equals",
          },
          typeId: {
            value: null,
            matchmode: "equals",
          },
        },
      },
    };
  },
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BTableSimple,
    BBadge,
    BIconEyeFill,
    BPagination,
    BFormInput,
    BFormSelect,
  },
  computed: {
    contractorFilledOptions() {
      return [
        { value: null, text: this.$t("All") },
        { value: true, text: this.$t("contractorFilledYes") },
        { value: false, text: this.$t("contractorFilledNo") },
      ];
    },
    typeOptions() {
      return [
        { value: null, text: this.$t("All") },
        { value: 1, text: this.$t("MPTypeComplaint") },
        { value: 2, text: this.$t("MPTypeSuggestion") },
        { value: 3, text: this.$t("MPTypeApplication") },
      ];
    },
  },
  created() {
    this.Refresh();
  },
  methods: {
    isContractorFilled(item) {
      return !!item.isContractorFilled;
    },
    Refresh() {
      InspectionBookService.GetList(this.filter)
        .then((res) => {
          this.Requests = res.data.rows;
          this.filter.totalRows = res.data.total;
        })
        .catch((error) => {
          this.$message(error.response.data);
        });
    },
    View(item) {
      this.$router.push({
        name: "InspectionBookCombinedView",
        params: { id: item.id },
        query: {
          inspectionBookId: item.inspectionBookId,
          inspectionBookOfContractorId: item.inspectionBookOfContractorId,
        },
      });
    },
    Fill(item) {
      this.$router.push({
        name: "InspectionBookCombinedEdit",
        params: { id: item.id },
        query: {
          inspectionBookId: item.inspectionBookId,
          inspectionBookOfContractorId: item.inspectionBookOfContractorId,
        },
      });
    },
  },
};
</script>

<style>
.nav-link {
  color: #293958 !important;
}
/* Make the contractor-filled select match the filter text inputs */
.filter-select.custom-select {
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-color: #fff;
}
.filter-select.custom-select:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>
